import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { http } from './api'

export interface AuditLogItem {
  id: string
  entityType: string
  entityId: string
  action: string
  actorName: string | null
  actorId: string | null
  channel: 'WEB' | 'MCP' | 'SCHEDULER' | 'IMPORT' | 'MANUAL'
  diff: Record<string, unknown> | null
  createdAt: string
}

export interface AuditLogFilters {
  entityType?: string
  channel?: string
  actor?: string
  from?: string
  to?: string
}

interface AuditLogResponse {
  items: AuditLogItem[]
  total: number
  page: number
  perPage: number
}

export function useAuditLog(filters: AuditLogFilters, page: number, enabled: boolean) {
  return useQuery({
    queryKey: ['audit-log', filters, page],
    queryFn: () => {
      const params: Record<string, string | number> = { page, perPage: 50 }
      for (const [key, value] of Object.entries(filters)) {
        if (value) params[key] = value
      }
      return http.get<AuditLogResponse>('/api/audit-log', params)
    },
    placeholderData: keepPreviousData,
    enabled,
  })
}
